module.exports = __webpack_public_path__ + "img/user-icon.7e054ece.svg";